import { decodeEdifyJwtPayload } from './jwtPayload.ts'

const DEFAULT_THRESHOLD_SECONDS = 48 * 3600

export const getJwtSecondsUntilExpiry = (
  accessToken: string
): number | null => {
  const p = decodeEdifyJwtPayload(accessToken)
  if (typeof p?.exp !== 'number') {
    return null
  }
  return Math.max(0, p.exp - Math.floor(Date.now() / 1000))
}

export const jwtShouldProactiveRefresh = (
  accessToken: string,
  thresholdSeconds: number = DEFAULT_THRESHOLD_SECONDS
): boolean => {
  const left = getJwtSecondsUntilExpiry(accessToken)
  if (left === null || left <= 0) {
    return false
  }
  return left < thresholdSeconds
}
